'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListCover = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/ListCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {};

var ListCover = exports.ListCover = function (_BcReactComponent) {
  _inherits(ListCover, _BcReactComponent);

  function ListCover() {
    _classCallCheck(this, ListCover);

    return _possibleConstructorReturn(this, (ListCover.__proto__ || Object.getPrototypeOf(ListCover)).apply(this, arguments));
  }

  _createClass(ListCover, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-4 col-md-3 cp-list-cover' },
        _react2.default.createElement(
          'div',
          { className: 'list-cover' },
          this.props.children
        )
      );
    }
  }]);

  return ListCover;
}(_baseBcReactComponent2.default);

ListCover.propTypes = propTypes;

exports.default = ListCover;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-list-cover/lib/components/ListCover.component.js
// module id = 1191
// module chunks = 0